import { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import SpotifyPlaylistSearch from './components/SpotifyPlaylistSearch';
import SpotifyCallback from './components/SpotifyCallback';

function App() {
  useEffect(() => {
    window.onerror = function(message, source, lineno, colno, error) {
      console.error('Global error:', {message, source, lineno, colno, error});
      alert('Une erreur est survenue : ' + message);
    };
  }, []);

  return (
    <Routes>
      <Route path="/" element={<SpotifyPlaylistSearch />} />
      <Route path="/callback" element={<SpotifyCallback />} />
    </Routes>
  );
}

export default App;